import { Course, CourseAuthor } from "@jelly/lesson";
import { Html, Icon, PreviewModal, Scrollbars } from "@jelly/ui";
import React, { useEffect, useState } from "react";

import styles from "../CourseWelcome.module.scss";

interface CourseWelcomeAuthorsListProps {
  course: Course;
}

const CourseWelcomeAuthorsList: React.FC<CourseWelcomeAuthorsListProps> = (props) => {
  const [modalData, setModalData] = useState<CourseAuthor | null>();

  useEffect(() => {
    if (props.course) {
      document.title = `ASKNow - Course ${props.course.publicId} authors page`;
    }
  }, [props.course]);

  const renderAuthor = (author: CourseAuthor): React.ReactNode => {
    return (
      <div className={styles.authorItem} onClick={() => setModalData(author)}>
        <div className={styles.photo}>
          <img src={author.imageUrl} alt={author.name} />
        </div>
        <p className={styles.name}>{author.name}</p>
        <span className={styles.title}>{author.title}</span>
        <Icon className={"cil-arrow-right"} theme={"primary"} />
      </div>
    );
  };

  const renderModal = (): React.ReactNode => {
    const modalContent = (
      <div className={styles.detailsModal}>
        <div className={styles.side}>
          <img src={modalData?.imageUrl} alt={modalData?.name} />
        </div>
        <div className={styles.main}>
          <h1>{modalData?.name}</h1>
          <p>
            <Html>{modalData?.description || ""}</Html>
          </p>
        </div>
      </div>
    );

    return <PreviewModal visible={!!modalData} content={modalContent} onClose={() => setModalData(null)} />;
  };

  return (
    <>
      <h1>Course Content Team</h1>
      <p>{props.course.authorsDescription}</p>
      <div className={styles.content}>
        <Scrollbars autoHeight autoHeightMin="610px">
          <div className={styles.authorsList}>{props.course.authors?.map((author) => renderAuthor(author))}</div>
        </Scrollbars>
      </div>
      <div className={styles.modal}>{renderModal()}</div>
    </>
  );
};

export default CourseWelcomeAuthorsList;
